import orderlistView from '@/components/apps/pos/sale/main/common/OrderList.vue'
import totalpriceView from '@/components/apps/pos/sale/main/common/TotalPrice.vue'
import calculatorView from '@/components/apps/pos/sale/main/common/Calculator.vue'
import otherPaymentForm from '@/components/apps/pos/sale/main/common/OtherPaymentForm.vue'
import { mapGetters, mapActions } from 'vuex'
import { POS_PAYMENT_METHOD } from '@/helpers/enum'
import { getMasterData, getMasterDataText } from '@/helpers'
import _ from 'lodash'
import { uuid } from 'vue-uuid'

export default {
  components: {
    orderlistView,
    totalpriceView,
    calculatorView,
    otherPaymentForm,
  },
  data () {
    return {
      disabledBtnEnter: false,
      POS_PAYMENT_METHOD: POS_PAYMENT_METHOD,
      paymentMethod: POS_PAYMENT_METHOD.CASH,
    }
  },
  computed: {
    ...mapGetters({
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // current table number selected
      getTableById: 'getPosTableById', // table info
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      getPosTotalPriceById: 'getPosTotalPriceById', // get total price from table number
      network_status: 'getNetworkStatus', // online return true, offline return false,
      customer_id: 'getPosSelectedCustomerId', // selected customer_id
      customer_new: 'getPosSelectedCustomerNew', // selected customer_new
      posSession: 'getPosSession', // pos session info
      getCustomerById: 'getCustomerById', // customer info
      products: 'getPosProducts',
      posSettings: 'getPosSetting',
      getPosSelectedDiningName: 'getPosSelectedDiningName',
      posSettings: 'getPosSetting',
      getPosQueueById: 'getPosQueueById',
      getLang: 'getLang',
      recipes: 'getRecipes',
    }),
    orders () {
      return this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
    },
    isOffline () {
      return this.network_status == false
    },
    customerInfo () {
      return this.getCustomerById(this.customer_id)
    },
    tableInfo () {
      return this.getTableById(this.table_number)
    },
    totalPrice () {
      const result = this.getPosTotalPriceById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      }, this.mixin)
      return result.total
    },
    paymentMethodsButtons() {
      return this.posSettings.payment.methods
        .filter((item) => item.is_active)
        .map((item) => {
          const data = getMasterData(item.name)
          return {
            btnClass: [
              'btn',
              this.paymentMethod === data.name ? 'btn-secondary' : 'btn-light',
            ],
            name: data.name,
            text: getMasterDataText(item.name, this.$t),
          }
        })
    },
    use_dining () {
      return this.posSettings.dining.is_active
    },
    use_queue () {
      return this.posSettings.queue.is_active
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'addPosOrder',
      'addPosStockBill',
      'insertPosBill',
      'setReceiptInfo',
      'setEventKeyboardStatus',
      'clearPosSelectedDiningName',
    ]),
    setUI () {
      var orderSectionHeight = $('.orders-section').outerHeight()
      var totalPriceHeight = $('.total-price').outerHeight()
      var resultHeight = totalPriceHeight

      if (this.use_table) {
        resultHeight += buttonTableHeight
      }

      $('.order-list').css({
        height: (orderSectionHeight - resultHeight - 1) + 'px',
      })
    },
    handleWindowResize (event) {
      var that = this
      setTimeout(() => {
        // set ui
        that.setUI()
      }, 10)
    },
    genDiscount (discounts) {
      var arr = []
      for (let discount of discounts) {
        if (discount.value_type !== null) {
          arr.push({
            'name': discount.discount_name,
            'type': discount.type,
            'value_type': discount.value_type,
            'value_amount': discount.value_amount,
          })
        }
      }
      return arr
    },
    genTax (taxes) {
      var arr = []
      for (let i in taxes) {
        arr.push({
          'tax_id': taxes[i].tax_id,
          'form_type': taxes[i].form_type,
          'name': taxes[i].tax_name,
          'type': taxes[i].type,
          'amount': taxes[i].amount,
          'group_name': taxes[i].group_name,
          'is_display_fee_result': taxes[i].is_display_fee_result,
          'is_for_sale': taxes[i].is_for_sale,
          'is_for_purchase': taxes[i].is_for_purchase,
          'fee': taxes[i].fee,
        })
      }
      return arr
    },
    genModifier (modifiers) {
      var arr = []
      for (let i in modifiers) {
        for (let j in modifiers[i].options) {
          arr.push({
            option: modifiers[i].options[j].option,
            price: modifiers[i].options[j].price,
          })
        }
      }
      return arr
    },
    async onSubmit (isValid, number, paymentMethod, isUseKeyboardNumber, isUseKeyboardEnter) {
      if (this.disabledBtnEnter) {
        return
      }

      this.disabledBtnEnter = true

      let paidNumber = number
      let totalPrice = this.getPosTotalPriceById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      }, this.mixin) // get total price

      const table_duration_in_second = this.tableInfo
        ? Math.round((Date.now() - this.tableInfo.start_at) / 1000)
        : null

      const queue = this.getPosQueueById(this.queue_number)

      // call api to insert bill
      let data = {
        'request_id': uuid.v1(),
        'request_count': 1,
        'total': totalPrice.total,
        'dining': {
          'type': this.use_dining
            ? getMasterData(this.getPosSelectedDiningName).name
            : null,
        },
        'payment': {
          'type': paymentMethod,
          'amount': paidNumber,
        },
        'created_at': new Date().toISOString(),
        'orders': [],
        'branch_id': this.posSession.branch_id,
        'ps_id': this.posSession.ps_id,
        'ps_code': this.posSession.ps_code,
        'analytics': {
          'queue_number': this.queue_number,
          'table_number': this.table_number,
      		'table_duration_in_second': table_duration_in_second,
      		'is_use_keyboard_number': isUseKeyboardNumber,
      		'is_use_keyboard_enter': isUseKeyboardEnter,
          'is_sync_manual': null,
        },
        'ps_qrcode_id': queue && queue.qrcode_id ? queue.qrcode_id : null,
        'ps_qrcode_type': queue && queue.qrcode_type ? queue.qrcode_type : null,
        'lang': this.getLang,
      }

      if (this.customer_id !== null) {
        data['customer_id'] = this.customer_id
        data['customer_new'] = this.customer_new
      }

      if (this.use_queue && this.orders.length && this.orders[0].queue_number != null) {
        data['posbi_code'] = this.orders[0].queue_number
      }

      for (let i in this.orders) {
        let order = this.orders[i]
        let orderSet = {
          'item': order.item,
          'price': order.price,
          'cost': order.cost,
          'quantity': parseFloat(order.quantity),
          'modifiers': this.genModifier(order.modifiers),
          'discounts': this.genDiscount(order.discounts),
          'taxes': this.genTax(order.taxes),
          'sku_id': order.sku_id,
        }
        if (order.note !== undefined && order.note !== null) {
          orderSet['note'] = order.note
        }
        if (order.stock_id && order.warehouse_id) {
          orderSet['stockout'] = {
            warehouse_id: order.warehouse_id,
            bin_location_id: order.bin_location_id,
            stock_id: order.stock_id,
          }
        }
        if (order.lots) {
          orderSet.lot_numbers = order.lots.map((lot) => {
            return {
              'lot_id': lot.lotId,
              'lot_code': lot.lotCode,
              'bin_location_id': lot.binId,
              'unit': lot.unit,
            }
          })
        } else if (order.serials) {
          orderSet.serial_numbers = order.serials.map((ser) => {
            return {
              'bin_location_id': ser.binId,
              'ser_id': ser.serId,
              'ser_code': ser.serCode,
              'serial_number': ser.serialNumber,
            }
          })
        }
        const recipes = this.recipes.reduce((acc, cur) => {
          const hasAssigned = cur.assign_skus.some((assignSkuItem) => assignSkuItem.sku_id === order.sku_id)
          if (hasAssigned) {
            acc = [
              ...acc,
              ...cur.stock_skus,
            ]
          }
          return acc
        }, [])
        if (recipes.length) {
          orderSet['recipes'] = recipes
        }
        data.orders.push(orderSet)
      }

      if (this.isOffline) {
        this.insertPosBill(data)
        // loading finish
        this.showFinish(this.$Progress)
        // set section
        this.setPosSection('payment-complate')
      } else {
        let res = await this.insertPosBill(data)

        if (this.use_queue) {
          this.$store.dispatch('getPosBillUSedCodes', {
            ps_id: this.$route.query.id,
          })
        }

        if (res.success) {
          // set data
          this.setReceiptInfo({
            paid: paidNumber,
            change: paidNumber - totalPrice.total,
            bi_code: res.data.bill.posbi_code,
            paymentMethod: this.paymentMethod,
            customer: this.customerInfo,
            created_at: res.data.bill.created_at,
            posbi_id: res.data.bill._id,
          })
        }

        const currentQueueNumber = _.cloneDeep(this.queue_number)
        const currentTableNumber = _.cloneDeep(this.table_number)

        // set default dining option
        this.clearPosSelectedDiningName({
          queue_number: currentQueueNumber,
          table_number: currentTableNumber,
        })

        // loading finish
        this.showFinish(this.$Progress)
        // set section
        this.setPosSection('payment-complate')
      }
    },
    handleSelectPaymentMethod (paymentMethod) {
      this.paymentMethod = paymentMethod
    },
    setDefaultPaymentmethod () {
      this.paymentMethod = (() => {
        const name = this.posSettings.payment.methods.find((item) => item.is_default).name
        const data = getMasterData(name)
        return data.name
      })()
    },
  },
  beforeMount () {
    this.setDefaultPaymentmethod()
  },
  mounted: function () {
    this.$nextTick(() => {
      this.setUI()
    })

    window.addEventListener('resize', this.handleWindowResize)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/payment.js